import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitKontrolleM1} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {DataStorageService} from 'shared/services/data-storage.service';
import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';
import {MatrixTotalTableData} from './matrix-total-table/matrix-total-table-data';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {GlobalConfig} from 'shared/global-config';

@Component({
  templateUrl:
    './pruefung-kombinationen-unabhaengiger-variablen.component.html',
  styleUrl: '../../../cockpit-shared/contents/cockpit-styles.scss',
  standalone: false
})
export class PruefungKombinationenUnabhaengigerVariablenComponent
  implements CockpitContentComponent, OnInit
{
  @ViewChild('bknAusbildungTable', {read: ElementRef})
  bknAusbildungTableComponent!: ElementRef;
  @ViewChild('bstAusbildungTable', {read: ElementRef})
  bstAusbildungTableComponent!: ElementRef;
  @ViewChild('bstBknTable', {read: ElementRef})
  bstBknTableComponent!: ElementRef;

  card: CockpitCard;
  tableHeaders = [
    'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.title',
    'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table2.title',
    'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table3.title'
  ];
  bknAusbildungData: MatrixTotalTableData;
  bstAusbildungData: MatrixTotalTableData;
  bknBstData: MatrixTotalTableData;

  constructor(
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService
  ) {}

  async ngOnInit() {
    const cockpitData =
      (await this.storage.getCockpitKontrolle()) as CockpitKontrolleM1;
    if (!cockpitData) {
      return;
    }
    const data = cockpitData.kombinationVonUnabhaengigenVariablen;
    this.bknAusbildungData = this.prepareData(
      data.BKNAusbildung,
      'BKN',
      GlobalConfig.anfMax,
      'Ausbildung',
      8
    );
    this.bstAusbildungData = this.prepareData(
      data.BSTAusbildung,
      'BST',
      5,
      'Ausbildung',
      8
    );
    this.bknBstData = this.prepareData(
      data.BSTBKN,
      'BST',
      5,
      'BKN',
      GlobalConfig.anfMax
    );
  }

  exportBknAusbildungTable() {
    this.tableExport.exportHtmlTableInElement(
      this.bknAusbildungTableComponent.nativeElement,
      'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table1.title'
    );
  }

  exportBstAusbildungTable() {
    this.tableExport.exportHtmlTableInElement(
      this.bstAusbildungTableComponent.nativeElement,
      'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table2.title'
    );
  }

  exportBstBknTable() {
    this.tableExport.exportHtmlTableInElement(
      this.bstBknTableComponent.nativeElement,
      'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.table3.title'
    );
  }

  prepareData(
    object: Record<string, number | null>,
    rowProp: string,
    rows: number,
    colProp: string,
    cols: number
  ): MatrixTotalTableData {
    const matrix = [];
    const totalColumn = [];
    const totalRow = [];
    for (let rowIndex = 1; rowIndex <= rows; rowIndex++) {
      const resultRow = [];
      for (let colIndex = 1; colIndex <= cols; colIndex++) {
        const key = `${rowProp}${rowIndex}${colProp}${colIndex}`;
        const element = this.checkAndGetElement(object, key);
        resultRow.push(element);
      }
      matrix.push(resultRow);
      const rowTotalKey = `${rowProp}${rowIndex}Total`;
      totalColumn.push(this.checkAndGetElement(object, rowTotalKey));
    }
    for (let colIndex = 1; colIndex <= cols; colIndex++) {
      const colTotalKey = `${colProp}${colIndex}Total`;
      totalRow.push(this.checkAndGetElement(object, colTotalKey));
    }
    const totalKey = `${rowProp}Total${colProp}Total`;
    const total = this.checkAndGetElement(object, totalKey);
    return {matrix, totalColumn, totalRow, total};
  }

  private checkAndGetElement(
    object: Record<string, number | null>,
    key: string
  ): number | null {
    if (!Object.prototype.hasOwnProperty.call(object, key)) {
      throw Error(`No key '${key}' found in ${typeof object}`);
    }
    const element = object[key];
    return element;
  }
}
